import styled from '@emotion/styled';
import { StyledButton } from '@selfserve/react-ui';
import { AnswerData } from '../data';
import { Checkbox } from '@kep-ui-kit/ui-components';

const StyledCheckboxButton = styled(
  StyledButton,
  {}
)(({ theme, odd }: { theme?: any; odd?: boolean }) => ({
  fontSize: '14px',
  marginRight: '0',
  marginBottom: '16px',
  fontWeight: '500',
  borderColor: theme.palette.grey['400'],
  justifyContent: 'left',
  padding: '11px 8px 11px 8px',
  flexBasis: 'calc(50% - 8px)',
  height: '40px',
  fontFamily: 'Lato',
  [theme.breakpoints.down('sm')]: {
    flexBasis: '100%',
  },

  '&.selected': {
    borderColor: '#006EFA',
  },

  ...(odd && {
    '&:last-child': {
      flexBasis: '100%',
    },
  }),
}));

const StyledCheckboxControl = styled(
  Checkbox,
  {}
)(() => ({
  marginBottom: '0px',
  marginRight: '8px',
}));

interface Props {
  handleAnswerSelected: any;
  answer: AnswerData;
  odd?: boolean;
}

export const MarketingInfoCheckbox = ({
  handleAnswerSelected,
  answer,
  odd,
}: Props) => {
  const { selected, answerName, text } = answer;

  return (
    <StyledCheckboxButton
      id={answerName}
      name={answerName}
      key={answerName}
      fullWidth
      isBorderless
      onClick={handleAnswerSelected}
      className={selected ? 'selected' : ''}
      odd={odd}
    >
      <StyledCheckboxControl checked={selected} className="noMarginBottom" />
      {text}
    </StyledCheckboxButton>
  );
};
